import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {FBColumnOptions} from "FormBuilder/Core/FBColumn.Options";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FieldFactory} from "FormBuilder/FieldFactory";
import {FBFieldBase} from "FormBuilder/Fields/Core/FBFieldBase";

export class FieldContainerManagerBase<T extends ContainerDataRetriever> {
    public Container:T;
    static LastFieldId:number;
    public LastFieldWithErrors:FBFieldBaseModel;
    constructor(Container:T)
    {
        this.Container=Container;
    }

    GetRows():FBRowModel[]{
        return this.Container.Rows;
    }

    GetFields(includeFieldsOfRepeaters=false,IncludeFieldsOfParentContainers=false, includeFieldsOfGroupPanel:boolean=true): FBFieldBaseModel[] {
        let fields:FBFieldBaseModel[]=[];
        for(let row of this.Container.Rows)
        {
            for(let column of row.Columns)
            {
                let field=column.Field;
                fields.push(field);

                if(field.Options.Type==FieldTypeEnum.GroupPanel&&includeFieldsOfGroupPanel)
                {
                    for(let subFields of (field as any as ContainerDataRetriever).ContainerManager.GetFields(true))
                        fields.push(subFields);
                }

                if(includeFieldsOfRepeaters&&(field.Options.Type==FieldTypeEnum.Repeater||field.Options.Type==FieldTypeEnum.RepeaterItem))
                {
                    for(let subFields of (field as any as ContainerDataRetriever).ContainerManager.GetFields(true))
                        fields.push(subFields);
                }
            }
        }


        if(IncludeFieldsOfParentContainers)
        {
            if(this.Container.FormBuilder!=null)
                fields=fields.concat(this.Container.FormBuilder.ContainerManager.GetFields(false,true).filter(x=>!fields.some(y=>x.Options.Id==y.Options.Id)));
        }

        return fields;
    }

    GetNextFieldId(): number {

        FieldContainerManagerBase.LastFieldId++;
        return FieldContainerManagerBase.LastFieldId;
    }





    GetFieldIndex(field:FBFieldBaseModel):{Row:number,Column:number}
    {
        return {
            Column:field.Parent.Parent.Columns.indexOf(field.Parent),
            Row:field.FormBuilder.Rows.indexOf(field.Parent.Parent)
        }
    }

    GetFieldById(id: any,searchInChildContainer:boolean=false,searchInParentContainers:boolean=false):FBFieldBaseModel {
        for(let field of this.GetFields()) {
            if (field.Options.Id == id)
                return field;

            if(searchInChildContainer&&(field as any as ContainerDataRetriever).ContainerManager!==undefined)
            {
                field=(field as any as ContainerDataRetriever).ContainerManager.GetFieldById(id,true);
                if(field!=null)
                    return field;
            }
        }

        if(searchInParentContainers&&this.Container.FormBuilder!=null)
        {
            return this.Container.FormBuilder.ContainerManager.GetFieldById(id,false,true);
        }


        return null;
    }

    GetRowByFieldId(fieldId:number,searchInChildContainer:boolean=false):FBRowModel
    {
        let field=this.GetFieldById(fieldId,searchInChildContainer);
        if(field!=null)
            return field.Parent.Parent;
        return null;
    }


    GetRootContainer():ContainerDataRetriever{
        let container:ContainerDataRetriever=this.Container;
        while(container.FormBuilder!=null)
            container=container.FormBuilder;

        return container;

    }


    public Validate() {
        let isValid=true;
        this.LastFieldWithErrors=null;
        for(let field of this.GetFields(false,false,false))
        {
            if(!field.Validate()) {
                isValid = false;
                if(this.LastFieldWithErrors==null)
                    this.LastFieldWithErrors=field;
            }
        }



        return isValid;
    }
}